<template lang="pug">
#loader-bg(v-show='isLoading')
	#loader
		img(src='../assets/load.gif', alt='Now Loading')
		p Now Loading...
</template>

<style lang="stylus" scoped>
//Loading表示用
#loader-bg
	position: fixed
	width: 100%
	height: 100%
	top: 0px
	left: 0px
	background: rgba(255, 255, 255, 0.8)
	z-index: 1100
	#loader
		position: fixed
		top: 35%
		left: 50%
		width: 500px
		margin-left: -250px
		text-align: center
		p
			margin-top: 5px
			font-size: 17px
			font-weight: bold
			color: #486a8c
</style>

<script>
import bus from '@/service/EventBus'
export default {
  data () {
    return {
      isLoading: false
    }
  },
  mounted () {
    // EventBusからグローバルに制御を受け取る
    bus.$on('loader', (display) => {
      this.isLoading = display
    })
  }
}
</script>



// WEBPACK FOOTER //
// Loader.vue?043e7d1e